
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AcceptProtocol',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['cancel', 'confirm', 'openUserProtocol', 'openPrivacyProtocol'],
  setup(_props, { emit }) {
    const cancel = () => {
      emit('cancel')
    }

    const confirm = () => {
      emit('confirm')
    }

    const openUserProtocol = () => {
      emit('openUserProtocol')
    }

    const openPrivacyProtocol = () => {
      emit('openPrivacyProtocol')
    }

    return {
      cancel,
      confirm,
      openUserProtocol,
      openPrivacyProtocol
    }
  }
})
